module.exports = __webpack_public_path__ + "img/upsell_shape.61125739.svg";